import { isIframe } from '@/lib/utils';
import IframeWindowService from '@/lib/IframeWindowService';
import BrowserWindowService from '@/lib/BrowserWindowService';

const state = {
  windowService: null
};

const mutations = {
  SET_WINDOW_SERVICE(state, windowService) {
    state.windowService = windowService;
  }
};

const getters = {
  browserLanguage() {
    const language = navigator.language;
    switch (language) {
      case 'en':
        return 'en-US';
      case 'ko':
        return 'ko-KR';
      case 'ja':
        return 'ja-JP';
      case 'zh':
        return 'zh-CN';
      default:
        return language;
    }
  }
};

const actions = {
  initWindowService({ commit }, router) {
    let windowService;
    if (isIframe()) {
      windowService = new IframeWindowService(router);
      windowService.initObservers();
    } else windowService = new BrowserWindowService(router);

    commit('SET_WINDOW_SERVICE', windowService);
  }
};

export default { namespaced: true, state, mutations, getters, actions };
